import { render, staticRenderFns } from "./FiltroCoopUnne.vue?vue&type=template&id=2da92a1c"
import script from "./FiltroCoopUnne.vue?vue&type=script&lang=js"
export * from "./FiltroCoopUnne.vue?vue&type=script&lang=js"
import style0 from "./FiltroCoopUnne.vue?vue&type=style&index=0&id=2da92a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports